import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";
import moment from "moment";
import { useSelector } from "react-redux";
import AdminDiamondReportService from "../../../services/reports-AdminDiamond-service";
import { Button, DatePicker, Select, Table, Tooltip } from "antd";
import { BlobToDownloadFile } from "../../../helper/commanFunction";

const { RangePicker } = DatePicker;

const DiamondClicks = () => {
  const { t } = useTranslation();
  const { Option } = Select;

  const initialGlobalDiamondState = {
    dataRangeFrom: moment().subtract(30, "days").format("YYYY-MM-DD"),
    dataRangeTo: moment().format("YYYY-MM-DD"),
    SelectedDiamondValue: "All",
    retailerIds: [],
    vendorIds: [],
  };
  const [topDiamondKey, setTopDiamondKey] = useState(true);
  const [recentDiamondKey, setRecentDiamondKey] = useState(true);
  const [loading, setLoading] = useState(false);
  const [CSVLoading, setCSVLoading] = useState(false);
  const [PDFLoading, setPDFLoading] = useState(false);
  const [
    TopDiamondAttributeValuesTableList,
    setTopDiamondAttributeValuesTableList,
  ] = useState([]);
  const [
    RecentDiamondAttributeSearchesTableList,
    setRecentDiamondAttributeSearchesTableList,
  ] = useState([]);
  const [dealerId, setDealerId] = useState();
  const loginDetials = useSelector((state) => state.loginReducer);
  const [forDealer, setForDealer] = useState("");
  const [globalDiamonds, setGlobalDiamond] = useState(
    initialGlobalDiamondState
  );
  const [isApplyFilter, setIsApplyFilter] = useState(false);
  const [TotalDiamondRecords, setTotalDiamondRecords] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [sortOrderCol, setsortOrderCol] = useState("date");
  const [sortOrderType, setsortOrderType] = useState("desc");

  const onDateChange = (dates, dateStrings) => {
    if (dates) {
      setGlobalDiamond((prevState) => ({
        ...prevState,
        dataRangeFrom: dateStrings[0],
        dataRangeTo: dateStrings[1],
      }));
    } else {
    }
  };

  function handleOnChange(e, isSelect, name) {
    setGlobalDiamond({
      ...globalDiamonds,
      [name]: e,
    });
  }

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleCheckDealermembers(
            loginDetials.loginDetials.responseData.dealerId
          );
        }
      }
    }
  }, []);

  const handleCheckDealermembers = (id) => {
    let inputData = {
      dealerID: id,
    };

    AdminDiamondReportService.CheckDealermembers(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        var forDealer = responseData.forDealer;
        if (message === "Success") {
          if (Object.keys(responseData).length !== 0) {
            setForDealer(forDealer);
          } else {
            setForDealer("");
          }
          handleGetTopDiamondAttributeValuesList(id, forDealer);
          handleGetRecentDiamondAttributeSearchesList(
            id,
            forDealer,
            pageNo,
            pageSize,
            sortOrderCol,
            sortOrderType
          );
        } else {
          setForDealer("");
        }
      })
      .catch((error) => {
        setForDealer("");
      });
  };

  const handleGetTopDiamondAttributeValuesList = (dealerId, forDealer) => {
    let inputData = {
      dealerID: dealerId.toString(),
      forDealer: forDealer ? forDealer.toString() : "",
      fromDate: globalDiamonds.dataRangeFrom,
      toDate: globalDiamonds.dataRangeTo,
      retailerIds: globalDiamonds.retailerIds.toString(),
      vendorIds: globalDiamonds.vendorIds.toString(),
      selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
    };
    setLoading(true);
    AdminDiamondReportService.GetTopDiamondAttributeTableList(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        var tempArray = [];
        tempArray.push(responseData);
        if (message === "Success") {
          setTopDiamondAttributeValuesTableList(tempArray);
        } else {
          setTopDiamondAttributeValuesTableList([]);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      })
      .finally(() => setLoading(false));
  };




  const handleDownloadCSVReports = () => {
    let inputData = {
      dealerID: dealerId.toString(),
      forDealer: forDealer ? forDealer.toString() : "",
      fromDate: globalDiamonds.dataRangeFrom,
      toDate: globalDiamonds.dataRangeTo,
      clarity: "",
      cutGrade: "",
      shape: "",
      color: "",
      size: "",
      certificate: "",
      reporttype: "Global",
      selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
      pageNumber: pageNo,
      pageSize: pageSize,
      sortOrderCol: "date",
      sortOrderType: "asc",
    };
    setCSVLoading(true);
    AdminDiamondReportService.GetCSVChartForTableList(inputData)
      .then((response) => {
        
        setCSVLoading(false);
        var fileName =
          "DiamondClicks_Report" +
          new Date().toJSON().slice(0, 10).split("-").reverse().join("/") +
          ".csv";
        BlobToDownloadFile(response.data, fileName);
      })
      .catch((error) => {
        setCSVLoading(false);
      });
  };

  const handleDownloadPDFReports = () => {
    let inputData = {
      dealerID: dealerId.toString(),
      forDealer: forDealer ? forDealer.toString() : "",
      fromDate: globalDiamonds.dataRangeFrom,
      toDate: globalDiamonds.dataRangeTo,
      clarity: "",
      cutGrade: "",
      shape: "",
      color: "",
      size: "",
      certificate: "",
      reporttype: "Global",
      selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
      pageNumber: pageNo,
      pageSize: pageSize,
      sortOrderCol: "date",
      sortOrderType: "asc",
    };
    setPDFLoading(true);
    AdminDiamondReportService.GetPDFChartForTableList(inputData)
      .then((response) => {
        setPDFLoading(false);
        var fileName =
          "DiamondClicks_Report" +
          new Date().toJSON().slice(0, 10).split("-").reverse().join("/") +
          ".pdf";
        BlobToDownloadFile(response.data, fileName, "pdf");
      })
      .catch((error) => {
        setPDFLoading(false);
      });
  };


  const handleGetRecentDiamondAttributeSearchesList = (
    dealerId,
    forDealer,
    pageNo,
    pageSize,
    sortOrderCol,
    sortOrderType
  ) => {
    let inputData = {
      dealerID: dealerId.toString(),
      forDealer: forDealer ? forDealer.toString() : "",
      fromDate: globalDiamonds.dataRangeFrom,
      toDate: globalDiamonds.dataRangeTo,
      clarity: "",
      cutGrade: "",
      shape: "",
      color: "",
      size: "",
      certificate: "",
      reporttype: "Global",
      selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
      pageNumber: pageNo,
      pageSize: pageSize,
      sortOrderCol: sortOrderCol || "date",
      sortOrderType: sortOrderType || "DESC",
    };
    setLoading(true);
    AdminDiamondReportService.GetRecentDiamondAttributeTableList(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          setRecentDiamondAttributeSearchesTableList(
            responseData.diamondVendorTableChartresp
          );
          setTotalDiamondRecords(responseData.totalCount);
        } else {
          setRecentDiamondAttributeSearchesTableList([]);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      })
      .finally(() => setLoading(false));
  };

  const handleApplyFilter = () => {
    setTopDiamondKey(!topDiamondKey);
    setRecentDiamondKey(!recentDiamondKey);
    handleCheckDealermembers(dealerId);
    setIsApplyFilter(!isApplyFilter);
  };

  const handleTableASCDES = (pagination, filters, sorter) => {
    var tableBody = document.querySelector(".pendjewelreq__tbl .ant-table-body"); if (tableBody) tableBody.scrollTop = 0;
    var type = "";
    var column = "";
    //sorting
    if (sorter.order == "descend") {
      type = "DESC";
      column = sorter.field;
      setsortOrderType(type);
      setsortOrderCol(column);
    } else if (sorter.order == "ascend") {
      type = "ASC";
      column = sorter.field;
      setsortOrderType(type);
      setsortOrderCol(column);
    } else {
      type = "DESC";
      column = "date";
      setsortOrderCol(column);
      setsortOrderType(type);
    }
    setPageNo(pagination.current);
    setPageSize(pagination.pageSize);
    handleGetRecentDiamondAttributeSearchesList(
      dealerId,
      forDealer,
      pagination.current,
      pagination.pageSize,
      column,
      type
    );
  };

  return (
    <React.Fragment>
      <div className="pendjewelreq__section form__fields">
        <div className="row magento__mapping">
          <div className="col-md-12">
            <div className="heading__block mobile-m-0">
              <h4 class="workarea__heading mt-0 mb-0">{t("Diamond Clicks")}</h4>
            </div>
          </div>
          <div className="col-md-4">
            <div className="input__block dataRange-input-block">
              <label> {t("Date Range")} </label>

              <RangePicker
                className="date-range-input"
                ranges={{
                  Today: [moment(), moment()],
                  Yesterday: [
                    moment().subtract(1, "days"),
                    moment().subtract(1, "days"),
                  ],
                  "Last 7 Days": [moment().subtract(7, "days"), moment()],
                  "Last 30 Days": [moment().subtract(30, "days"), moment()],
                  "This Month": [
                    moment().startOf("month"),
                    moment().endOf("month"),
                  ],
                  "Last Month": [
                    moment().subtract(1, "month").startOf("month"),
                    moment().subtract(1, "months").endOf("month"),
                  ],
                  "Last 90 Days": [moment().subtract(90, "days"), moment()],
                  "Year To Date": [moment().startOf("year"), moment()],
                }}
                format={"MM-DD-YYYY"}
                onChange={onDateChange}
                defaultValue={[moment().subtract(30, "days"), moment()]}
                defaultPickerValue={[moment().subtract(30, "days"), moment()]}
              />
            </div>
          </div>

          <div className="col-md-3">
            <div className="input__block">
              <label> {t("Select Diamond")} </label>
              <Select
                showSearch
                className="border__grey"
                placeholder={t("All")}
                optionFilterProp="children"
                name="SelectedDiamondValue"
                value={
                  globalDiamonds.SelectedDiamondValue
                    ? globalDiamonds.SelectedDiamondValue
                    : null
                }
                onChange={(e) =>
                  handleOnChange(e, "select", "SelectedDiamondValue")
                }
              >
                <Option value="All"> {t("All")} </Option>
                <Option value="Mined"> {t("Mined Diamond")} </Option>
                <Option value="Lab"> {t("Lab Grown Diamond")} </Option>
              </Select>
            </div>
          </div>

          <div className="col-md-4">
            <div className="input__block">
              <button
                className="primary-btn mobile-mt-0"
                style={{ marginTop: 25 }}
                onClick={handleApplyFilter}
              >
                {" "}
                {t("Apply Filter")}{" "}
              </button>
            </div>
          </div>

          <div className="col-lg-12 col-md-6 mt-4 mobile-m-0">
            <div className="input__block">
              <label>
                <b> {t("Top Diamond Attribute Values")} </b>
              </label>
            </div>
          </div>

          <div className="col-lg-12 col-md-12">
            <div className="table__scroll">
              <Table
                key={topDiamondKey}
                className="pendjewelreq__tbl"
                  scroll={{ x: 1200, y: "calc(100vh - 340px)" }}
                columns={[
                  {
                    title: <Tooltip title={t("Date")}>{t("Date")}</Tooltip>,
                    ellipsis: true,
                    dataIndex: "date",
                    showSorterTooltip: false,
                  },
                  {
                    title: <Tooltip title={t("Shape")}>{t("Shape")}</Tooltip>,
                    ellipsis: true,
                    dataIndex: "shape",
                    showSorterTooltip: false,
                  },
                  {
                    title: <Tooltip title={t("Size")}>{t("Size")}</Tooltip>,
                    ellipsis: true,
                    dataIndex: "size",
                    showSorterTooltip: false,
                  },
                  {
                    title: <Tooltip title={t("Color")}>{t("Color")}</Tooltip>,
                    ellipsis: true,
                    dataIndex: "color",
                    showSorterTooltip: false,
                  },
                  {
                    title: <Tooltip title={t("Cut")}>{t("Cut")}</Tooltip>,
                    ellipsis: true,
                    dataIndex: "cutGrade",
                    showSorterTooltip: false,
                  },
                  {
                    title: (
                      <Tooltip title={t("Clarity")}>{t("Clarity")}</Tooltip>
                    ),
                    ellipsis: true,
                    dataIndex: "clarity",
                    showSorterTooltip: false,
                  },
                  {
                    title: <Tooltip title={t("Price")}>{t("Price")}</Tooltip>,
                    ellipsis: true,
                    dataIndex: "price",
                    showSorterTooltip: false,
                  },
                ]}
                loading={loading}
                dataSource={TopDiamondAttributeValuesTableList}
              />
            </div>
          </div>

          <div className="col-lg-12 col-md-6 mt-4 mobile-m-0">
            <div className="input__block">
              <label>
                <b> {t("Recent Diamond Attribute Searches")} </b>
              </label>
            </div>
          </div>
          <div className="col-lg-12 mt-3 d-flex flex-column flex-lg-row justify-content-lg-end mb-3">
            {forDealer && (
              <>
                <Button
                  className="primary-btn mr-2"
                  onClick={handleDownloadPDFReports}
                  loading={PDFLoading}
                >
                  {" "}
                  <i className="fa fa-download"></i> {t("Download PDF")}
                </Button>
                <Button
                  className="primary-btn mr-2"
                  onClick={handleDownloadCSVReports}
                  loading={CSVLoading}
                >
                  {" "}
                  <i className="fa fa-download"></i> {t("Download CSV")}
                </Button>
              </>
            )}
          </div>
          <div className="col-lg-12 col-md-12">
            <Table
              key={recentDiamondKey}
              className="pendjewelreq__tbl"
                  scroll={{ x: 1200, y: "calc(100vh - 340px)" }}
              columns={[
                {
                  title: (
                    <Tooltip title={t("UsersIPAddress")}>
                      {t("UsersIPAddress")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "usersIPAddress",
                  showSorterTooltip: false,
                  sorter: (a, b) =>
                    a.usersIPAddress.localeCompare(b.usersIPAddress),
                },
                {
                  title: (
                    <Tooltip title={t("Day & Time")}>{t("Day & Time")}</Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "date",
                  defaultSortOrder: "descend",
                  sorter: (a, b) => { },
                  showSorterTooltip: false,
                  render: (row, item) => {
                    //

                    if (Object.keys(item.date).length !== 0) {
                      return (
                        <React.Fragment>
                          <span>
                            {moment(item.date).format("MM-DD-YYYY, hh:mm:ss A")}
                          </span>
                        </React.Fragment>
                      );
                    }
                  },
                },
                {
                  title: <Tooltip title={t("Shape")}>{t("Shape")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "shape",
                  showSorterTooltip: false,
                  sorter: (a, b) => { },
                },
                {
                  title: <Tooltip title={t("Size")}>{t("Size")}</Tooltip>,
                  ellipsis: true,
                  showSorterTooltip: false,
                  dataIndex: "size",
                  sorter: (a, b) => { },
                },
                {
                  title: <Tooltip title={t("Color")}>{t("Color")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "color",
                  showSorterTooltip: false,
                  sorter: (a, b) => { },
                },
                {
                  title: <Tooltip title={t("Cut")}>{t("Cut")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "cutGrade",
                  showSorterTooltip: false,
                  sorter: (a, b) => { },
                },
                {
                  title: <Tooltip title={t("Clarity")}>{t("Clarity")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "clarity",
                  showSorterTooltip: false,
                  sorter: (a, b) => { },
                },
                {
                  title: (
                    <Tooltip title={t("Certificates")}>
                      {t("Certificates")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "certificate",
                  showSorterTooltip: false,
                  sorter: (a, b) => { },
                },
                {
                  title: (
                    <Tooltip title={t("Retail Price")}>
                      {t("Retail Price")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "retailPrice",
                  showSorterTooltip: false,
                  sorter: (a, b) => { },
                  render: (retailPrice) => (
                    <Tooltip title={retailPrice}>
                      <span>{retailPrice}</span>
                    </Tooltip>
                  ),
                },
                {
                  title: <Tooltip title={t("Cost")}>{t("Cost")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "cost",
                  showSorterTooltip: false,
                  sorter: (a, b) => { },
                  render: (cost) => (
                    <Tooltip title={cost}>
                      <span>{cost}</span>
                    </Tooltip>
                  ),
                },
              ]}
              loading={loading}
              dataSource={RecentDiamondAttributeSearchesTableList}
              pagination={{
                size: "small",
                total: TotalDiamondRecords,
                pageNo: pageNo,
                pageSize: pageSize,
                pageSizeOptions: [10, 15, 20, 50, 100],
                responsive: true,
                showSizeChanger: true,
              }}
              onChange={handleTableASCDES}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DiamondClicks;
